import React, { useContext } from 'react';
import TwitterFillIcon from 'components/lib/icons/twitter_fill_icon';
import FloorboardRow from './floorboard_row';
import LiveboardContext from 'components/liveboards/contexts/liveboard_context.jsx';

export default function TwitterRow() {
  const { channel, sla } = useContext(LiveboardContext);

  const stats = channel.twitter;
  const callSla = sla.twitter;
  return (
    <FloorboardRow
      newItems={stats.currentNewMessages}
      activeItems={stats.currentOpenMessages}
      currentWait={stats.currentWait}
      sla={callSla}
      activeLabel="Open Messages"
      newLabel="New Messages"
      waitLabel="Oldest Unanswered Message"
      icon={<TwitterFillIcon />}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/floorboard/twitter_row.jsx